import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateProjetModalComponent } from '../create-projet-modal/create-projet-modal.component';

@Component({
  selector: 'app-create-projet-button',
  template: `
    <button 
      *ngIf="showButton" 
      mat-raised-button 
      color="primary" 
      (click)="openModal()">
      Créer un projet pour {{ request.agencyName }}
    </button>
  `,
  styles: [`
    button { margin-top: 10px; }
  `]
})
export class CreateProjetButtonComponent {
  @Input() request: any; // The request object from the list

  constructor(private dialog: MatDialog) {}

  // Condition: only show if operation='ajout', type='projet', status='approuvé'
  get showButton(): boolean {
    return this.request &&
           this.request.operation === 'ajout' &&
           this.request.type === 'projet' &&
           this.request.status === 'approuvé';
  }

  openModal(): void {
    this.dialog.open(CreateProjetModalComponent, {
      width: '700px',
      data: {
        agencyName: this.request.agencyName,
        // Pre-fill any other fields available in the request
        prefillName: this.request.projectName || '',
        prefillDescription: this.request.description || '',
        // add more as needed
      }
    });
  }
}